import { useSearchParams } from 'react-router-dom';

import { useCallback } from 'react';
import Item from './Item';
import { getPageItems } from './utils';

import { PaginationProps } from './types';

import { usePaginationStyles } from './styles';

const Pagination = ({ pagesCount }: PaginationProps) => {
  const styles = usePaginationStyles();

  const [searchParams, setSearchParams] = useSearchParams();

  const currentPage = Number(searchParams.get('page') || 1);
  const pageItems = getPageItems({ pagesCount, page: currentPage });

  const setCurrentPage = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (page: number) => {
      setSearchParams(params => {
        params.set('page', String(page));
        return params;
      });
    },
    [setSearchParams],
  );

  return (
    <nav className={styles.root}>
      {pageItems.map((item, i) => (
        <Item
          key={`${item}${i}`}
          page={item}
          isActive={currentPage === item}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      ))}
    </nav>
  );
};

export default Pagination;
